<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-ligth" aria-label="Ninth navbar example">
        <div class="container-xl">
          <a class="navbar-brand" @click="$router.push('/inicio').catch(err => {})"><img src="@/assets/img/logo.png" alt="logo" class="logo-kallpa"></a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample07XL" aria-controls="navbarsExample07XL" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
    
          <div class="collapse navbar-collapse" id="navbarsExample07XL">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="https://kallpasab.com/#about" target="_blank">¿Quiénes somos? </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="$router.push('/preguntas').catch(err => {})">Preguntas frecuentes</a>
              </li>
<!--            <li class="nav-item">
                <a class="nav-link" @click="$router.push('/Reclamos').catch(err => {})">
                  <img src="@/assets/img/reclamo.png" alt="reclamo" width="40">
                  Reclamaciones</a>
              </li>>-->
            </ul>
                <div class="d-flex">
                    <router-link to="/auth-login">
                    <button type="button" class="btn btn-iniciar-sesion me-2">Iniciar sesión</button>
                    </router-link> 
                    <router-link to="/auth-registro">
                    <button type="button" class="btn btn-registro">Regístrate</button> 
                    </router-link>
                </div>
          </div>
        </div>
    </nav>
</template>

<script>
import helpers from "@/services/helpers";

export default {
  name: "Menu",
  methods:{
    validarPermisos(permiso){
      return helpers.validarPermisoActual(this, permiso);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/Menu.vue